import React, { PureComponent } from 'react';
import { Map, List, fromJS } from 'immutable';
import { injectIntl, defineMessages } from 'react-intl';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as common from 'libs/commonFunc';
import * as templateLib from 'libs/templateLib';
import * as templateActions from 'modules/template';
import * as templateAttachActions from 'modules/templateAttach';

import { ExamTemplateList } from 'components';

let SEARCH_VALUE = '';
class CtExamTemplateList extends PureComponent {
  constructor(props) {
    super(props);

    // 검색 기록 유지
    const { paramData } = this.props;
    const filterData = paramData.get('filter').toJS();
    let searchTypeData = 'searchAll';
    let searchTextData = '';
    if (Object.keys(filterData).length) {
      const searchOptions = [
        'searchAll',
        'serviceNo',
        'serviceName',
        'attachSubject',
        'templateName',
        'senderName',
        'senderEmail',
        'subject'
      ];
      searchOptions.map(option => {
        if (filterData[option]) {
          searchTypeData = option;
          searchTextData = filterData[option];
        }
      });
    }

    this.state = {
      loading: false,
      fromNowView: false,
      fitRowCount: 0,
      currentPage: 0,
      pageSize: 0,
      searchType: searchTypeData,
      tempFilter: {}
    };
  }

  componentWillMount() {
    // 화면 사이즈(높이)에 해당하는 리스트의 개수 설정
    let fitRowCount = Math.trunc((window.innerHeight - 315) / 48);
    fitRowCount = fitRowCount < 5 ? 5 : fitRowCount;

    this.handleInitFilter();
    this.setState({ pageSize: fitRowCount, fitRowCount });
  }

  componentDidUpdate(prevProps) {
    const { needReload, paramData, examSummary } = this.props;
    if (
      needReload !== prevProps.needReload ||
      // parameter가 변경되었을때
      paramData !== prevProps.paramData ||
      // 훈련 실시했을 때
      examSummary !== prevProps.examSummary
    ) {
      this.getTemplate();
    }
  }

  getTemplate = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { TemplateActions, TemplateAttachActions, paramData } = this.props;
        const { currentPage, pageSize } = this.state;
        const params = {
          filter: JSON.stringify(paramData.get('filter')),
          sort: JSON.stringify(paramData.get('sort')),
          offset: pageSize * (currentPage < 0 ? 0 : currentPage), // page 는 0 번 부터 시작
          limit: pageSize < 1 ? 20 : pageSize
        };

        await TemplateActions.getTemplate(params);
        await TemplateAttachActions.getAttach();
        await TemplateActions.getTemplatePhishing();
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  //구분 필터
  isServiceTemplateFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['isServiceTemplateArray'] === 'undefined') {
      filter['isServiceTemplateArray'] = [data.value];
    } else {
      const indexArray = filter['isServiceTemplateArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['isServiceTemplateArray'].push(data.value);
      } else {
        filter['isServiceTemplateArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['isServiceTemplateArray'].length === 0 && delete filter['isServiceTemplateArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //훈련유형 필터
  examTypeTemplateFilter = data => {
    const { tempFilter } = this.state;
    const filter = Object.assign({}, tempFilter);

    if (typeof filter['examTypeArray'] === 'undefined') {
      filter['examTypeArray'] = [data.value];
    } else {
      const indexArray = filter['examTypeArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['examTypeArray'].push(data.value);
      } else {
        filter['examTypeArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['examTypeArray'].length === 0 && delete filter['examTypeArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //다운로드 유형 필터
  downloadTypeTemplateFilter = data => {
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['linkAttachArray'] === 'undefined') {
      filter['linkAttachArray'] = [data.value];
    } else {
      const indexArray = filter['linkAttachArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['linkAttachArray'].push(data.value);
      } else {
        filter['linkAttachArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['linkAttachArray'].length === 0 && delete filter['linkAttachArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  //수신 성공필터
  receiveTemplateFilter = data => {
    const { tempFilter } = this.state;

    const filter = Object.assign({}, tempFilter);
    if (typeof filter['templateReceiveArray'] === 'undefined') {
      filter['templateReceiveArray'] = [data.value];
    } else {
      const indexArray = filter['templateReceiveArray'].findIndex(filterItem => filterItem === data.value);
      if (indexArray === -1) {
        filter['templateReceiveArray'].push(data.value);
      } else {
        filter['templateReceiveArray'].splice(indexArray, 1);
        // 필터 array가 없다면 삭제
        filter['templateReceiveArray'].length === 0 && delete filter['templateReceiveArray'];
      }
    }

    this.setState({
      tempFilter: filter
    });
  };

  // 필터 처리
  // 정렬 처리
  handleFetchData = ({ ...rest }) => {
    const { sorted } = rest;
    const sort = [];
    if (sorted && Array.isArray(sorted)) {
      // 정렬이 적용됨
      for (let i = 0; i < sorted.length; i++) {
        const data = sorted[i];
        sort.push({ field: data.id, order: data.desc ? 'DESC' : 'ASC' });
      }
    }

    const { TemplateActions } = this.props;
    TemplateActions.changeParam({
      name: 'sort',
      value: fromJS(sort)
    });
  };

  // 검색 타입 선택
  handleSearchOptions = (e, { value }) => {
    this.setState({ searchType: value });
  };

  // 검색어 입력
  handleChangeSearch = e => {
    this.setState({ searchText: e.target.value });
  };

  // 검색
  handleOnSearch = e => {
    if (
      e.key === 'Enter' ||
      e.target.id === 'bt-search-input' ||
      e.target.parentNode.id === 'bt-search-input' ||
      e.target.parentNode.parentNode.id === 'bt-search-input'
    ) {
      const searchType = this.state.searchType;
      const searchValue = SEARCH_VALUE;

      const { TemplateActions, paramData } = this.props;
      const filter = paramData.get('filter').toJS();

      if (searchValue !== filter[searchType]) {
        // 검색 타입 제거
        const searchOptions = [
          'searchAll',
          'serviceNo',
          'serviceName',
          'attachSubject',
          'templateName',
          'senderName',
          'senderEmail',
          'subject'
        ];
        searchOptions.map(option => delete filter[option]);

        if (searchValue !== '') {
          filter[searchType] = searchValue;
        }

        this.setState({ currentPage: 0 });
        TemplateActions.changeParam({
          name: 'filter',
          value: fromJS(filter)
        });
      }
    }
  };

  // 체크 취소
  cancleCheck = () => {
    const { TemplateActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter
    });
  };

  // // 개별 필터
  // handleChangeFilter = (column, value, isMulti) => {
  //   const { TemplateActions, paramData } = this.props;
  //   const filter = paramData.get('filter').toJS();

  //   // 멀티 선택 필터
  //   if (isMulti) {
  //     if (typeof filter[column] === 'undefined') {
  //       filter[column] = value;
  //     } else if (Number(filter[column]) === Number(value)) {
  //       delete filter[column];
  //     } else {
  //       if (Number(value) & Number(filter[column])) {
  //         filter[column] = Number(filter[column]) - Number(value);
  //       } else {
  //         filter[column] = Number(filter[column]) + Number(value);
  //       }
  //     }
  //     // 단일 선택 필터
  //   } else {
  //     if (filter[column] === value) {
  //       delete filter[column];
  //     } else {
  //       filter[column] = value;
  //     }
  //   }

  //   this.setState({ currentPage: 0 });
  //   TemplateActions.changeParam({
  //     name: 'filter',
  //     value: fromJS(filter)
  //   });
  // };

  // 날짜 필터
  handleChangeDateFilter = (type, data) => {
    const { TemplateActions, paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    if (data.startDate) {
      filter['start' + type] = data.startDate;
    }
    if (data.endDate) {
      filter['end' + type] = data.endDate;
    }

    this.setState({ currentPage: 0 });
    TemplateActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  // 필터 초기화
  handleInitFilter = () => {
    const { TemplateActions } = this.props;

    TemplateActions.changeParam({
      name: 'filter',
      value: Map({})
    });

    if (this.myTextInput && this.myTextInput.inputRef.value !== '') {
      this.myTextInput.inputRef.value = '';
    }

    this.setState({ searchType: 'searchAll', searchText: '', tempFilter: {} });
  };

  // 페이지 이동 처리
  handlePagination = pageNo => {
    this.setState({ currentPage: pageNo });
  };

  // 페이지 개수 처리 (페이지 초기화)
  handlePageSizeOnChange = (obj, value) => {
    this.setState({ pageSize: value.value, currentPage: 0 });
  };

  // 검색 입력값 받아오기
  takeSearchValue = searchValue => {
    SEARCH_VALUE = searchValue;
  };

  searchTextRef = ref => {
    this.myTextInput = ref;
  };

  //필터 팝업 클로즈
  filterClose = () => {
    const { paramData } = this.props;
    const filter = paramData.get('filter').toJS();

    this.setState({
      tempFilter: filter,
      isLoading: false
    });
  };

  //체크한 필터 실행
  executeFilter = () => {
    const { TemplateActions } = this.props;
    const { tempFilter } = this.state;
    const filter = tempFilter;

    this.setState({ currentPage: 0 });
    TemplateActions.changeParam({
      name: 'filter',
      value: fromJS(filter)
    });
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;

    const { loading, fromNowView, currentPage, pageSize, fitRowCount, searchType, searchText, tempFilter } = this.state;
    const { isAuth, templateData, attachData, templatePhishing, attachIndexList, totalPages, totalCount, paramData } = this.props;
    const { handleFetchData } = this;
    // 검색
    const {
      handleSearchOptions,
      handleChangeSearch,
      handleOnSearch,
      isServiceTemplateFilter,
      examTypeTemplateFilter,
      downloadTypeTemplateFilter,
      receiveTemplateFilter,
      handleChangeDateFilter,
      handleInitFilter,
      takeSearchValue,
      searchTextRef,
      cancleCheck,
      filterClose,
      executeFilter
    } = this;
    // 페이징
    const { handlePagination, handlePageSizeOnChange } = this;

    const filterData = paramData.get('filter').toJS();
    let respData = {};
    if (templateData && Map.isMap(templateData)) {
      respData = templateData.toJS();
    }

    if (
      respData &&
      respData.result === 1 &&
      respData.success &&
      Array.isArray(respData.success) &&
      respData.success.length > 0
    ) {
      respData.success.map((tempData, index) => {
        // 피싱 템플릿
        const isPhishing = tempData.examType === 4 ? true : false;

        // 사용자 템플릿
        if (tempData.serviceTemplateNo) {
          respData.success[index].statistics = 'serviceTemplate';
          // 기본 템플릿
        } else {
          if (tempData.statisticsTarget > 0) {
            respData.success[index].statistics = {
              value:
                (isPhishing
                  ? defineMessages(
                    formatMessage({
                      id: 'CtExamTemplateList_1',
                      defaultMessage: '유출율'
                    })
                  )
                  : defineMessages(
                    formatMessage({
                      id: 'CtExamTemplateList_2',
                      defaultMessage: '감염율'
                    })
                  )) +
                ': ' +
                (tempData.statisticsInfection / tempData.statisticsTarget * 100).toFixed(0) +
                '% (' +
                tempData.statisticsInfection +
                defineMessages(formatMessage({ id: 'ExamDetail_45', defaultMessage: '명' })) +
                ')',
              detail: (
                <div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtExamTemplateList_3',
                          defaultMessage: '누적 훈련 대상'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsTarget +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtExamTemplateList_4',
                          defaultMessage: '누적 발송'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsSend +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {defineMessages(
                        formatMessage({
                          id: 'CtExamTemplateList_5',
                          defaultMessage: '누적 열람'
                        })
                      ) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsRead +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {(isPhishing
                        ? defineMessages(
                          formatMessage({
                            id: 'CtExamTemplateList_6',
                            defaultMessage: '누적 피싱 접속'
                          })
                        )
                        : defineMessages(
                          formatMessage({
                            id: 'CtExamTemplateList_7',
                            defaultMessage: '누적 다운'
                          })
                        )) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsRead +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  <div className="tempPopup-each">
                    <span>
                      {(isPhishing
                        ? defineMessages(
                          formatMessage({
                            id: 'CtExamTemplateList_8',
                            defaultMessage: '누적 정보 유출'
                          })
                        )
                        : defineMessages(
                          formatMessage({
                            id: 'CtExamTemplateList_9',
                            defaultMessage: '누적 감염'
                          })
                        )) + ': '}
                    </span>
                    <span>
                      {tempData.statisticsInfection +
                        defineMessages(
                          formatMessage({
                            id: 'ExamDetail_45',
                            defaultMessage: '명'
                          })
                        )}
                    </span>
                  </div>
                  {!isPhishing && (
                    <div className="tempPopup-each">
                      <span>
                        {defineMessages(
                          formatMessage({
                            id: 'CtExamTemplateList_10',
                            defaultMessage: '누적 치료'
                          })
                        ) + ': '}
                      </span>
                      <span>
                        {tempData.statisticsCure +
                          defineMessages(
                            formatMessage({
                              id: 'ExamDetail_45',
                              defaultMessage: '명'
                            })
                          )}
                      </span>
                    </div>
                  )}
                </div>
              )
            };
          } else {
            // respData.success[index].statistics = '0% (0/0)';
          }
        }
      });
    } else {
      // 응답 데이터 오류
    }

    const pageSizeArray = common.ArraySort(common.ArrayDuplicateRemove([5, 10, 20, 25, 50, 100, fitRowCount]));
    const pageSizeOptions = [];
    pageSizeArray.map(value => {
      pageSizeOptions.push({ text: value, value: value });
    });

    const searchOptions = [
      {
        key: 0,
        text: defineMessages(formatMessage({ id: 'Faq_1', defaultMessage: '전체' })),
        value: 'searchAll'
      },
      {
        key: 1,
        text: defineMessages(formatMessage({ id: 'AdminLog_4', defaultMessage: '서비스No' })),
        value: 'serviceNo'
      },
      {
        key: 2,
        text: defineMessages(formatMessage({ id: 'AdminLog_19', defaultMessage: '서비스명' })),
        value: 'serviceName'
      },
      {
        key: 3,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateList_33',
            defaultMessage: '첨부파일 정보'
          })
        ),
        value: 'attachSubject'
      },
      {
        key: 4,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateList_5',
            defaultMessage: '템플릿명'
          })
        ),
        value: 'templateName'
      },
      {
        key: 5,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateList_6',
            defaultMessage: '발송자명'
          })
        ),
        value: 'senderName'
      },
      {
        key: 6,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateList_7',
            defaultMessage: '발송자 이메일'
          })
        ),
        value: 'senderEmail'
      },
      {
        key: 7,
        text: defineMessages(
          formatMessage({
            id: 'ExamTemplateEdit_14',
            defaultMessage: '메일 제목'
          })
        ),
        value: 'subject'
      }
    ];

    return (
      <ExamTemplateList
        isAuth={isAuth}
        fromNowView={fromNowView}
        manual
        data={respData.success}
        attachData={attachData}
        templatePhishing={templatePhishing}
        attachIndexList={attachIndexList}
        totalCount={totalCount}
        page={currentPage}
        pages={totalPages}
        pageSize={pageSize}
        defaultPageSize={fitRowCount}
        pageSizeOptions={pageSizeOptions}
        loading={loading}
        onFetchData={handleFetchData}
        // 검색 영역
        searchObj={{
          filterData: filterData,
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: totalCount,
          searchType: searchType,
          searchText: searchText,
          searchOptions: searchOptions,
          handleSearchOptions: handleSearchOptions,
          handleChangeSearch: handleChangeSearch,
          handleOnSearch: handleOnSearch,
          handleInitFilter: handleInitFilter,
          defaultPageSize: fitRowCount,
          pageSizeOptions: pageSizeOptions,
          handlePageSizeOnChange: handlePageSizeOnChange,
          takeSearchValue: takeSearchValue,
          searchTextRef: searchTextRef,
          paramData: paramData,
          tempFilter: tempFilter
        }}
        // 필터
        isServiceTemplateFilter={isServiceTemplateFilter}
        examTypeTemplateFilter={examTypeTemplateFilter}
        downloadTypeTemplateFilter={downloadTypeTemplateFilter}
        receiveTemplateFilter={receiveTemplateFilter}
        cancleCheck={cancleCheck}
        filterClose={filterClose}
        executeFilter={executeFilter}
        handleChangeDateFilter={handleChangeDateFilter}
        // 페이징 처리
        handlePagination={handlePagination}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    templateData: state.template.get('data'),
    needReload: state.template.get('needReload'),
    totalPages: state.template.get('totalPages'),
    totalCount: state.template.get('totalCount'),
    paramData: state.template.get('param'),
    templatePhishing: state.template.getIn(['templatePhishing', 'success']),
    attachData: state.templateAttach.getIn(['data', 'success']),
    attachIndexList: state.templateAttach.get('listIndexByNo'),
    isAuth: state.user.get('isAuth'),
    examSummary: state.examSummary.get('examSummaryOrdering')
  };
};

const mapDispatchToProps = dispatch => ({
  TemplateActions: bindActionCreators(templateActions, dispatch),
  TemplateAttachActions: bindActionCreators(templateAttachActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamTemplateList));



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamTemplateList.js